var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/pipelineReport";
export default class PipelineReportService {
    static allStageConversionCounts({ stageIds, opportunityCreatedAfter, opportunitySourceIds, }) {
        return FetchService.getSingleResponse(BASE_URL + "/allStagesConversionCounts", {
            stageIds,
            opportunityCreatedAfter,
            opportunitySourceIds,
        });
    }
    static anyStagesConversionCounts({ stageIds, opportunityCreatedAfter, opportunitySourceIds, }) {
        return FetchService.getSingleResponse(BASE_URL + "/anyStagesConversionCounts", {
            stageIds,
            opportunityCreatedAfter,
            opportunitySourceIds,
        });
    }
    static averageStageDuration({ stageIds, opportunitySourceIds, }) {
        return FetchService.getSingleResponse(BASE_URL + "/averageStageDuration", {
            stageIds,
            opportunitySourceIds,
        });
    }
    static getStageEntryTimeline({ stageIds, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const results = yield FetchService.getSingleResponse(BASE_URL + "/stageEntryTimeline", {
                stageIds,
            });
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'r' implicitly has an 'any' type.
            return results.map((r) => (Object.assign(Object.assign({}, r), { date: new Date(r.date) })));
        });
    }
    static stageExitTimeline({ stageIds }) {
        return __awaiter(this, void 0, void 0, function* () {
            const results = yield FetchService.getSingleResponse(BASE_URL + "/stageExitTimeline", {
                stageIds,
            });
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'r' implicitly has an 'any' type.
            return results.map((r) => (Object.assign(Object.assign({}, r), { date: new Date(r.date) })));
        });
    }
}
